"use client"

import CommonTitle from "@/ui/common/bit/CommonTitle"
import { mediaQueries } from "@/ui/theme/theme"
import { styled } from "@mui/material"
import BlockWrapper from "../../common/BlockWrapper"

export const StyledBlockWrapper = styled(BlockWrapper)`
  align-items: center;
  gap: 48px;
  > .MuiButton-root {
    margin-top: 0;
  }
  ${mediaQueries.mobile} {
    max-width: unset;
    gap: 36px;
    padding: 60px 16px;
  }
  ${mediaQueries.desktopM} {
    gap: 56px;
  }
`

export const StyledCommonTitle = styled(CommonTitle)`
  margin-bottom: 0;
  ${mediaQueries.mobile} {
    text-align: center;
  }
  ${mediaQueries.desktopM} {
    max-width: 800px;
  }
  ${mediaQueries.desktopXl} {
    margin-bottom: 0;
  }
`
